import {Phone} from "lucide-react";

export function ContactLinks() {
    const phone = "+380686137593";
    const formattedPhone = "+38 (068) 613-75-93";

    return (
        <div className="contact-buttons">
            <a href={`tel:${phone}`} className={'transition-colors hover:text-emerald-600 flex'}><Phone className={'mx-1'} size={16} /> {formattedPhone}</a>
            <a href={`https://t.me/${phone}`} className={'mx-2 transition-colors hover:text-emerald-600'} target="_blank" rel="noreferrer">Telegram</a>
            <a href={`viber://chat?number=%2B${phone.replace('+', '')}`} className={'mx-2 transition-colors hover:text-emerald-600'}>Viber</a>
            <a href={`https://wa.me/${phone.replace('+', '')}`} target="_blank" rel="noreferrer" className={'transition-colors hover:text-emerald-600'}>WhatsApp</a>
        </div>
    );
}